<template>
  <div class="mb-8">
    <!-- Callback Partner ID -->
    <v-row>
      <v-col cols="12" md="8">
        <v-text-field
          id="callbackPartnerId"
          ref="callbackPartnerId"
          outlined
          label="Callback Partner ID *"
          v-model="localCallbackPartnerId"
          :rules="rules"
          :maxlength="36"
          autocomplete="off"
        />
      </v-col>
      <v-col cols="12" md="2" class="d-flex gap-2">
        <v-btn
          color="primary"
          @click="generateCallbackPartnerId"
          class="flex-grow-1 btn-custom rounded-pill elevation-0"
        >
          GENERATE
        </v-btn>
      </v-col>
      <v-col cols="12" md="2" class="d-flex gap-2">
        <v-btn
          outlined
          color="error"
          @click="resetCallbackPartnerId"
          class="flex-grow-1 btn-custom rounded-pill elevation-0"
        >
          RESET
        </v-btn>
      </v-col>
    </v-row>

    <!-- Callback Partner Client Secret -->
    <v-row>
      <v-col cols="12" md="8">
        <v-text-field
          id="callbackPartnerSecret"
          ref="callbackPartnerSecret" 
          outlined
          label="Callback Partner Client Secret *"
          v-model="localCallbackPartnerSecret"
          :rules="rules"
          :maxlength="36"
          autocomplete="off"
        />
      </v-col>
      <v-col cols="12" md="2" class="d-flex gap-2">
        <v-btn
          color="primary"
          @click="generateCallbackPartnerSecret"
          class="flex-grow-1 btn-custom rounded-pill elevation-0"
        >
          GENERATE
        </v-btn>
      </v-col>
      <v-col cols="12" md="2" class="d-flex gap-2">
        <v-btn
          outlined
          color="error"
          @click="resetCallbackPartnerSecret"
          class="flex-grow-1 btn-custom rounded-pill elevation-0"
        >
          RESET
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'CallbackPartnerFields',

  props: {
    callbackPartnerId: {
      type: String,
      default: ''
    },
    callbackPartnerSecret: {
      type: String,
      default: ''
    },
    rules: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      localCallbackPartnerId: '',
      localCallbackPartnerSecret: ''
    };
  },

  watch: {
    callbackPartnerId: {
      immediate: true,
      handler(val) {
        this.localCallbackPartnerId = val;
      }
    },
    callbackPartnerSecret: {
      immediate: true,
      handler(val) {
        this.localCallbackPartnerSecret = val;
      }
    },
    localCallbackPartnerId(val) {
      this.$emit('update:callbackPartnerId', val);
    },
    localCallbackPartnerSecret(val) {
      this.$emit('update:callbackPartnerSecret', val);
    }
  },

  methods: {
    generateRandomString(length = 10) {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let result = '';
      for (let i = 0; i < length; i += 1) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
      }
      return result;
    },

    generateCallbackPartnerId() {
      this.localCallbackPartnerId = this.generateRandomString(10);
    },

    generateCallbackPartnerSecret() {
      this.localCallbackPartnerSecret = this.generateRandomString(10);
    },

    resetCallbackPartnerId() {
      this.localCallbackPartnerId = '';
    },

    resetCallbackPartnerSecret() {
      this.localCallbackPartnerSecret = '';
    }
  }
};
</script>

<style scoped>
.gap-2 {
  gap: 8px;
}

.btn-custom {
  text-transform: uppercase;
  font-weight: 500;
  border-radius: 4px;
}

@media (max-width: 959px) {
  .btn-custom {
    height: 40px !important;
  }
}
</style>
